import { GET_LOGS_SKU_SUCCESS, GET_PRICE_ERRORS_SUCCESS } from './logs.type';

const initialState = {
    allLogs: [],
    priceErrors: [],
};


export const logsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGS_SKU_SUCCESS:
            return {
                ...state,
                allLogs: action.payload,
            };

        case GET_PRICE_ERRORS_SUCCESS:
            return {
                ...state,
                priceErrors: action.payload,
            };

        default:
            return state;
    }
};
